// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    .HomeBuyersGuide_div__42veP {
      display: flex;
      margin-top: 8px;
      flex-direction: column;
    }
    @media (max-width: 991px) {
      .HomeBuyersGuide_div__42veP {
        max-width: 100%;
        margin-top: 40px;
      }
    }
    .HomeBuyersGuide_div2__QjquE {
      color: #077aff;
      align-self: start;
      white-space: nowrap;
      width: 100%;
      justify-content: space-between;
      gap: 20px;
      padding: 11px 20px 0;
      font: 700 22px/28px Lato, sans-serif;
    }
    @media (max-width: 991px) {
      .HomeBuyersGuide_div2__QjquE {
        max-width: 100%;
        white-space: initial;
        flex-wrap: wrap;
      }
    }
    .HomeBuyersGuide_mainDiv__Y13xt {
      gap: 20px;
      display: flex;
    }
    .HomeBuyersGuide_sideBar__5TGb8 {
      gap: 20px;
      display: flex;
      min-height: 100%;
      justify-content: flex-start;
    }
    .HomeBuyersGuide_formInput__DPxFi {
        padding: 10px;
        font-size: 12px;
        border-width: 1px;
        border-color: #b1b1b1;
        background-color: #ffffff;
        color: #000000;
        border-style: solid;
        border-radius: 35px;
        display: flex;
        width: 40%;
        height: 15px;
        padding-left: 20px;
        padding-right: 60px;
      }
    .HomeBuyersGuide_div3__UA-iX {
      align-self: start;
      width: 1121px;
      max-width: 100%;
      padding-right: 15px;
      margin: 58px 0 0 14px;
    }
    @media (max-width: 991px) {
      .HomeBuyersGuide_div3__UA-iX {
        margin-top: 40px;
      }
    }
    .HomeBuyersGuide_div4__bJS1P {
      gap: 20px;
      display: flex;
    }
    @media (max-width: 991px) {
      .HomeBuyersGuide_div4__bJS1P {
        flex-direction: column;
        align-items: stretch;
        gap: 0px;
      }
    }
    .HomeBuyersGuide_column__Tm1l4 {
      display: flex;
      flex-direction: column;
      line-height: normal;
      width: 51%;
      margin-left: 0px;
    }
    @media (max-width: 991px) {
      .HomeBuyersGuide_column__Tm1l4 {
        width: 100%;
      }
    }
    .HomeBuyersGuide_div5__egnmo {
      display: flex;
      flex-direction: column;
    }
    @media (max-width: 991px) {
      .HomeBuyersGuide_div5__egnmo {
        max-width: 100%;
        margin-top: 40px;
      }
    }
    .HomeBuyersGuide_div6__sqZZV {
      color: #000;
      text-align: start;
      font-feature-settings: "clig" off, "liga" off;
      margin-top: 14px;
      white-space: nowrap;
      font: 500 36px/22px Poppins, -apple-system, Roboto, Helvetica,
        sans-serif;
    }
    @media (max-width: 991px) {
      .HomeBuyersGuide_div6__sqZZV {
        max-width: 100%;
        white-space: initial;
      }
    }
    .HomeBuyersGuide_div7__a\\+lFO {
      color: #000;
      text-align: start;
      font-feature-settings: "clig" off, "liga" off;
      margin-top: 39px;
      white-space: nowrap;
      font: 500 24px/22px Poppins, -apple-system, Roboto, Helvetica,
        sans-serif;
    }
    @media (max-width: 991px) {
      .HomeBuyersGuide_div7__a\\+lFO {
        max-width: 100%;
        white-space: initial;
      }
    }
    .HomeBuyersGuide_div8__Gf-bv {
      color: #000;
      text-align: start;
      font-feature-settings: "clig" off, "liga" off;
      margin-top: 33px;
      white-space: nowrap;
      font: 500 24px/22px Poppins, -apple-system, Roboto, Helvetica,
        sans-serif;
    }
    @media (max-width: 991px) {
      .HomeBuyersGuide_div8__Gf-bv {
        max-width: 100%;
        white-space: initial;
      }
    }
    .HomeBuyersGuide_div9__jyoLU {
      color: #000;
      text-align: start;
      font-feature-settings: "clig" off, "liga" off;
      margin-top: 43px;
      white-space: nowrap;
      font: 500 24px/22px Poppins, -apple-system, Roboto, Helvetica,
        sans-serif;
    }
    @media (max-width: 991px) {
      .HomeBuyersGuide_div9__jyoLU {
        max-width: 100%;
        margin-top: 40px;
        white-space: initial;
      }
    }
    .HomeBuyersGuide_div10__zcY7F {
      color: #000;
      text-align: start;
      font-feature-settings: "clig" off, "liga" off;
      margin-top: 30px;
      white-space: nowrap;
      font: 500 24px/22px Poppins, -apple-system, Roboto, Helvetica,
        sans-serif;
    }
    @media (max-width: 991px) {
      .HomeBuyersGuide_div10__zcY7F {
        max-width: 100%;
        white-space: initial;
      }
    }
    .HomeBuyersGuide_column2__0ku-F {
      display: flex;
      flex-direction: column;
      line-height: normal;
      width: 49%;
      margin-left: 20px;
    }
    @media (max-width: 991px) {
      .HomeBuyersGuide_column-2__HGvT\\+ {
        width: 100%;
      }
    }
    .HomeBuyersGuide_div11__w7h3Q {
      display: flex;
      flex-direction: column;
      overflow: hidden;
      position: relative;
      display: flex;
      min-height: 350px;
      margin-top: 23px;
      flex-grow: 1;
      align-items: center;
      padding: 50px 20px;
    }
    @media (max-width: 991px) {
      .HomeBuyersGuide_div11__w7h3Q {
        max-width: 100%;
        margin-top: 40px;
      }
    }
    .HomeBuyersGuide_img__ovrG- {
      position: absolute;
      height: 100%;
      width: 100%;
      object-fit: cover;
      object-position: center;
    }
    .HomeBuyersGuide_img2__SgVI2 {
      aspect-ratio: 0.94;
      object-fit: contain;
      object-position: center;
      width: 81px;
      overflow: hidden;
      max-width: 100%;
      margin: 71px 0 64px;
    }
    @media (max-width: 991px) {
      .HomeBuyersGuide_img2__SgVI2 {
        margin: 40px 0;
      }
    }`, "",{"version":3,"sources":["webpack://./src/components/HomeBuyersGuide.module.css"],"names":[],"mappings":";IACI;MACE,aAAa;MACb,eAAe;MACf,sBAAsB;IACxB;IACA;MACE;QACE,eAAe;QACf,gBAAgB;MAClB;IACF;IACA;MACE,cAAc;MACd,iBAAiB;MACjB,mBAAmB;MACnB,WAAW;MACX,8BAA8B;MAC9B,SAAS;MACT,oBAAoB;MACpB,oCAAoC;IACtC;IACA;MACE;QACE,eAAe;QACf,oBAAoB;QACpB,eAAe;MACjB;IACF;IACA;MACE,SAAS;MACT,aAAa;IACf;IACA;MACE,SAAS;MACT,aAAa;MACb,gBAAgB;MAChB,2BAA2B;IAC7B;IACA;QACI,aAAa;QACb,eAAe;QACf,iBAAiB;QACjB,qBAAqB;QACrB,yBAAyB;QACzB,cAAc;QACd,mBAAmB;QACnB,mBAAmB;QACnB,aAAa;QACb,UAAU;QACV,YAAY;QACZ,kBAAkB;QAClB,mBAAmB;MACrB;IACF;MACE,iBAAiB;MACjB,aAAa;MACb,eAAe;MACf,mBAAmB;MACnB,qBAAqB;IACvB;IACA;MACE;QACE,gBAAgB;MAClB;IACF;IACA;MACE,SAAS;MACT,aAAa;IACf;IACA;MACE;QACE,sBAAsB;QACtB,oBAAoB;QACpB,QAAQ;MACV;IACF;IACA;MACE,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,UAAU;MACV,gBAAgB;IAClB;IACA;MACE;QACE,WAAW;MACb;IACF;IACA;MACE,aAAa;MACb,sBAAsB;IACxB;IACA;MACE;QACE,eAAe;QACf,gBAAgB;MAClB;IACF;IACA;MACE,WAAW;MACX,iBAAiB;MACjB,6CAA6C;MAC7C,gBAAgB;MAChB,mBAAmB;MACnB;kBACY;IACd;IACA;MACE;QACE,eAAe;QACf,oBAAoB;MACtB;IACF;IACA;MACE,WAAW;MACX,iBAAiB;MACjB,6CAA6C;MAC7C,gBAAgB;MAChB,mBAAmB;MACnB;kBACY;IACd;IACA;MACE;QACE,eAAe;QACf,oBAAoB;MACtB;IACF;IACA;MACE,WAAW;MACX,iBAAiB;MACjB,6CAA6C;MAC7C,gBAAgB;MAChB,mBAAmB;MACnB;kBACY;IACd;IACA;MACE;QACE,eAAe;QACf,oBAAoB;MACtB;IACF;IACA;MACE,WAAW;MACX,iBAAiB;MACjB,6CAA6C;MAC7C,gBAAgB;MAChB,mBAAmB;MACnB;kBACY;IACd;IACA;MACE;QACE,eAAe;QACf,gBAAgB;QAChB,oBAAoB;MACtB;IACF;IACA;MACE,WAAW;MACX,iBAAiB;MACjB,6CAA6C;MAC7C,gBAAgB;MAChB,mBAAmB;MACnB;kBACY;IACd;IACA;MACE;QACE,eAAe;QACf,oBAAoB;MACtB;IACF;IACA;MACE,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,UAAU;MACV,iBAAiB;IACnB;IACA;MACE;QACE,WAAW;MACb;IACF;IACA;MACE,aAAa;MACb,sBAAsB;MACtB,gBAAgB;MAChB,kBAAkB;MAClB,aAAa;MACb,iBAAiB;MACjB,gBAAgB;MAChB,YAAY;MACZ,mBAAmB;MACnB,kBAAkB;IACpB;IACA;MACE;QACE,eAAe;QACf,gBAAgB;MAClB;IACF;IACA;MACE,kBAAkB;MAClB,YAAY;MACZ,WAAW;MACX,iBAAiB;MACjB,uBAAuB;IACzB;IACA;MACE,kBAAkB;MAClB,mBAAmB;MACnB,uBAAuB;MACvB,WAAW;MACX,gBAAgB;MAChB,eAAe;MACf,mBAAmB;IACrB;IACA;MACE;QACE,cAAc;MAChB;IACF","sourcesContent":["\n    .div {\n      display: flex;\n      margin-top: 8px;\n      flex-direction: column;\n    }\n    @media (max-width: 991px) {\n      .div {\n        max-width: 100%;\n        margin-top: 40px;\n      }\n    }\n    .div2 {\n      color: #077aff;\n      align-self: start;\n      white-space: nowrap;\n      width: 100%;\n      justify-content: space-between;\n      gap: 20px;\n      padding: 11px 20px 0;\n      font: 700 22px/28px Lato, sans-serif;\n    }\n    @media (max-width: 991px) {\n      .div2 {\n        max-width: 100%;\n        white-space: initial;\n        flex-wrap: wrap;\n      }\n    }\n    .mainDiv {\n      gap: 20px;\n      display: flex;\n    }\n    .sideBar {\n      gap: 20px;\n      display: flex;\n      min-height: 100%;\n      justify-content: flex-start;\n    }\n    .formInput {\n        padding: 10px;\n        font-size: 12px;\n        border-width: 1px;\n        border-color: #b1b1b1;\n        background-color: #ffffff;\n        color: #000000;\n        border-style: solid;\n        border-radius: 35px;\n        display: flex;\n        width: 40%;\n        height: 15px;\n        padding-left: 20px;\n        padding-right: 60px;\n      }\n    .div3 {\n      align-self: start;\n      width: 1121px;\n      max-width: 100%;\n      padding-right: 15px;\n      margin: 58px 0 0 14px;\n    }\n    @media (max-width: 991px) {\n      .div3 {\n        margin-top: 40px;\n      }\n    }\n    .div4 {\n      gap: 20px;\n      display: flex;\n    }\n    @media (max-width: 991px) {\n      .div4 {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 0px;\n      }\n    }\n    .column {\n      display: flex;\n      flex-direction: column;\n      line-height: normal;\n      width: 51%;\n      margin-left: 0px;\n    }\n    @media (max-width: 991px) {\n      .column {\n        width: 100%;\n      }\n    }\n    .div5 {\n      display: flex;\n      flex-direction: column;\n    }\n    @media (max-width: 991px) {\n      .div5 {\n        max-width: 100%;\n        margin-top: 40px;\n      }\n    }\n    .div6 {\n      color: #000;\n      text-align: start;\n      font-feature-settings: \"clig\" off, \"liga\" off;\n      margin-top: 14px;\n      white-space: nowrap;\n      font: 500 36px/22px Poppins, -apple-system, Roboto, Helvetica,\n        sans-serif;\n    }\n    @media (max-width: 991px) {\n      .div6 {\n        max-width: 100%;\n        white-space: initial;\n      }\n    }\n    .div7 {\n      color: #000;\n      text-align: start;\n      font-feature-settings: \"clig\" off, \"liga\" off;\n      margin-top: 39px;\n      white-space: nowrap;\n      font: 500 24px/22px Poppins, -apple-system, Roboto, Helvetica,\n        sans-serif;\n    }\n    @media (max-width: 991px) {\n      .div7 {\n        max-width: 100%;\n        white-space: initial;\n      }\n    }\n    .div8 {\n      color: #000;\n      text-align: start;\n      font-feature-settings: \"clig\" off, \"liga\" off;\n      margin-top: 33px;\n      white-space: nowrap;\n      font: 500 24px/22px Poppins, -apple-system, Roboto, Helvetica,\n        sans-serif;\n    }\n    @media (max-width: 991px) {\n      .div8 {\n        max-width: 100%;\n        white-space: initial;\n      }\n    }\n    .div9 {\n      color: #000;\n      text-align: start;\n      font-feature-settings: \"clig\" off, \"liga\" off;\n      margin-top: 43px;\n      white-space: nowrap;\n      font: 500 24px/22px Poppins, -apple-system, Roboto, Helvetica,\n        sans-serif;\n    }\n    @media (max-width: 991px) {\n      .div9 {\n        max-width: 100%;\n        margin-top: 40px;\n        white-space: initial;\n      }\n    }\n    .div10 {\n      color: #000;\n      text-align: start;\n      font-feature-settings: \"clig\" off, \"liga\" off;\n      margin-top: 30px;\n      white-space: nowrap;\n      font: 500 24px/22px Poppins, -apple-system, Roboto, Helvetica,\n        sans-serif;\n    }\n    @media (max-width: 991px) {\n      .div10 {\n        max-width: 100%;\n        white-space: initial;\n      }\n    }\n    .column2 {\n      display: flex;\n      flex-direction: column;\n      line-height: normal;\n      width: 49%;\n      margin-left: 20px;\n    }\n    @media (max-width: 991px) {\n      .column-2 {\n        width: 100%;\n      }\n    }\n    .div11 {\n      display: flex;\n      flex-direction: column;\n      overflow: hidden;\n      position: relative;\n      display: flex;\n      min-height: 350px;\n      margin-top: 23px;\n      flex-grow: 1;\n      align-items: center;\n      padding: 50px 20px;\n    }\n    @media (max-width: 991px) {\n      .div11 {\n        max-width: 100%;\n        margin-top: 40px;\n      }\n    }\n    .img {\n      position: absolute;\n      height: 100%;\n      width: 100%;\n      object-fit: cover;\n      object-position: center;\n    }\n    .img2 {\n      aspect-ratio: 0.94;\n      object-fit: contain;\n      object-position: center;\n      width: 81px;\n      overflow: hidden;\n      max-width: 100%;\n      margin: 71px 0 64px;\n    }\n    @media (max-width: 991px) {\n      .img2 {\n        margin: 40px 0;\n      }\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"div": `HomeBuyersGuide_div__42veP`,
	"div2": `HomeBuyersGuide_div2__QjquE`,
	"mainDiv": `HomeBuyersGuide_mainDiv__Y13xt`,
	"sideBar": `HomeBuyersGuide_sideBar__5TGb8`,
	"formInput": `HomeBuyersGuide_formInput__DPxFi`,
	"div3": `HomeBuyersGuide_div3__UA-iX`,
	"div4": `HomeBuyersGuide_div4__bJS1P`,
	"column": `HomeBuyersGuide_column__Tm1l4`,
	"div5": `HomeBuyersGuide_div5__egnmo`,
	"div6": `HomeBuyersGuide_div6__sqZZV`,
	"div7": `HomeBuyersGuide_div7__a+lFO`,
	"div8": `HomeBuyersGuide_div8__Gf-bv`,
	"div9": `HomeBuyersGuide_div9__jyoLU`,
	"div10": `HomeBuyersGuide_div10__zcY7F`,
	"column2": `HomeBuyersGuide_column2__0ku-F`,
	"column-2": `HomeBuyersGuide_column-2__HGvT+`,
	"div11": `HomeBuyersGuide_div11__w7h3Q`,
	"img": `HomeBuyersGuide_img__ovrG-`,
	"img2": `HomeBuyersGuide_img2__SgVI2`
};
export default ___CSS_LOADER_EXPORT___;
